import { useState } from "react";

/** What the registry match card remembers, owned by the form. */
export type RegistryMatchState = {
  defaultLegalName: string;
  dismissedForTaxId: string | null;
  onDismiss: (taxId: string) => void;
  acceptedLegalName: string | null;
  onAccept: (legalName: string) => void;
};

export function useRegistryMatchState(
  defaultLegalName: string,
): RegistryMatchState {
  const [dismissedForTaxId, onDismiss] = useState<string | null>(null);
  const [acceptedLegalName, onAccept] = useState<string | null>(null);
  return {
    defaultLegalName,
    dismissedForTaxId,
    onDismiss,
    acceptedLegalName,
    onAccept,
  };
}
